// ---------------------------------------
// External Libraries
// ---------------------------------------

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';

// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
// global.jQuery = require('jquery');

import 'lazysizes';
import 'parsleyjs';


// ---------------------------------------
// Internal modules
// ---------------------------------------

var Playtime = require('./playtime');
var Tabs = require('./tabs');
var Parsley = require('./parsley');
var Coupon = require('./coupon');

// ---------------------------------------
// Initialization
// ---------------------------------------

$(function() {
	Playtime.init();
	Tabs.init();
	Parsley.init();
	Coupon.init();

	// Remove password visiblity hover icon on woocommerce forms added in woocommerce.js
	var $passwordInput = $( '.woocommerce form .woocommerce-Input[type="password"]' );
	if ( $passwordInput.parent().is( '.password-input' ) ) {
		$passwordInput.unwrap();
	}
})
